<template>
  <el-dialog :visible="true" width="95%" :before-close="handleClose">
    <el-row :gutter="10" type="flex" justify="center" slot="title">
      <span class="fw400 fz26">权限配置</span>
    </el-row>
    <base-table
      :tableColumn="tableColumn"
      :data="tableData"
      :loading="tableLoading"
    />
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import baseTable from '@C/Base/baseTable';
import dateFormat from '@/tools/dateFormat';
import { projectV2 } from '@/api/ajax';
import baseTableMixin from '@C/Base/baseTableMixin';

export default {
  name: 'subAccount',
  components: { baseTable },
  mixins: [baseTableMixin],
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableColumn: [
        { label: '子账号', prop: 'userName' },
        {
          label: '创建时间',
          prop: 'createDt',
          formatter: v => dateFormat(v)
        },
        {
          label: '角色',
          prop: 'roleName'
          // formatter: v => INOUT_TYPE.get(+v)
        },
        {
          label: '姓名',
          prop: 'fullName'
          // formatter: v => PLATFORM_TYPE.get(+v)
        },
        { label: '联系方式', prop: 'phone' },
        { label: '部门', prop: 'department' },
        { label: '职位', prop: 'position' },
        {
          label: '操作',
          render: (h, { scope: { row } }) => {
            const { boundThisProject } = row;
            //boundThisProject 1：已关联此项目 0：未关联项目
            return h(
              'el-button',
              {
                props: {
                  type: 'text',
                  disabled: +boundThisProject === 1
                },
                on: {
                  click: () => {
                    this.$confirm(
                      `是否分配项目” ${this.data.projectName}“给子账号 ” ${row.userName}“？`,
                      '分配权限',
                      {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                      }
                    )
                      .then(() => {
                        const params = {
                          userId: row.userId, //	T文本	是 子账号用户ID
                          projectId: this.data.id, //T文本	是 项目ID
                          type: this.data.type //T文本	是 1:xcx_project 2:doctor_project 从项目列表数据中可获取
                        };
                        projectV2.assignProjectPerm(params).then(() => {
                          this.$message({
                            type: 'success',
                            message: '分配成功!'
                          });
                          this._initTableData();
                          this.$emit('updated');
                        });
                      })
                      .catch(() => {});
                  }
                }
              },
              '分配权限'
            );
          }
        }
      ]
    };
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    // 初始 表格列表数据
    _initTableData() {
      if (this.tableLoading) return;
      this.tableLoading = true;
      this.$nextTick(async () => {
        const { type, id } = this.data;
        const params = Object.assign(
          {
            type: type,
            projectId: id
          }
          // this.tableSearchParams,
          // this.tablePageQuery
        );
        const {
          data: {
            data: { list }
          }
        } = await projectV2.subAccountManagement(params);
        this.tableData = list;
        // this.tableTotal = total;
        this.tableLoading = false;
      });
    }
  },
  created() {
    this._initTableData();
  }
};
</script>

<style scoped></style>
